import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticGtc = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findGtcSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useGtcQuery {
		squidex {
			findGtcSingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					header {
						de {
							title
						}
					}

					content {
						de {
							title
							text
						}
					}

					file {
						iv {
							localFile {
								publicURL
							}
							...SquidexLocalFileProps
						}
					}
				}
			}
		}
	}
`;
